import axios from 'axios';
import jwt_decode from 'jwt-decode';
import router from '../../router';
import store from '../../store';

const baseURL = process.env.VUE_APP_API_URL;
const timeout = process.env.VUE_APP_TIME_OUT;

const api = axios.create({
  // baseURL: ,
  baseURL,
  timeout,
  // headers: { 'X-Custom-Header': 'foobar' },
});

// 토큰 갱신 실패 시 호출할 함수
const handleTokenRefreshFailure = () => {
  // store.commit('logout'); // 스토어에서 사용자 정보 삭제
  if (store.state.auth.user) {
    store.state.auth.user.accessToken = null;
    store.state.auth.user.refreshToken = null;
  }
  localStorage.removeItem('isAutoLogin');
  router.push('/login');
};


api.interceptors.request.use(
    async (config) => {
      if (store.state.auth.user) {
        let {accessToken, refreshToken}  = store.state.auth.user;

        if (accessToken && refreshToken) {
          const jwtObject = jwt_decode(accessToken);

          // 토큰만료 시간이 지난 경우 갱신 처리
          if (new Date().getTime() >= jwtObject.exp) {
            await axios
            .put(`${baseURL}/admin/api/auth`, {
              accessToken,
              refreshToken,
            })
            .then((response) => {
              if (response.data.accessToken) {
                const jwtObject = jwt_decode(response.data.accessToken);

                const retParams = { ...jwtObject };

                console.log(
                    '=========== FIND data.centerChains ===================='
                );
                console.log(response.data, retParams);
                console.log('===============================');

                retParams.accessToken = response.data.accessToken;
                retParams.refreshToken = response.data.refreshToken;
                retParams.centerId = retParams.cid;
                retParams.userId = retParams.lid;
                retParams.userName = retParams.unm;
                retParams.roleId = retParams.rid;
                retParams.roleName = retParams.rnm;
                retParams.centerChains =
                    response.data.centerChains;

                // localStorage.setItem(
                //     'userInfo',
                //     JSON.stringify(retParams)
                // );

                store.commit('loginSuccess', retParams)
                accessToken = response.data.accessToken;

                console.log('===> 토큰 갱신 성공 ');
              } else {
                handleTokenRefreshFailure();
              }
            });
          }
          config.headers.common.Authorization = `Bearer ${accessToken}`;
          //config.headers.common["Access-Control-Allow-Origin"] = '*';
          //config.headers['Access-Control-Allow-Origin'] = '*';
        } else {
          // 세션 만기시, 전체 세션관련 캐시 버리기
          if (refreshToken) {
            api.delete(
                `/admin/api/auth/${refreshToken}`
            );
            // localStorage.removeItem('userInfo');
            localStorage.removeItem('userMenu');
            localStorage.removeItem('menuEventCds');
          }
          handleTokenRefreshFailure();
        }
      }
      return config;
    },
    (error) => {
      // 요청 에러 처리
      console.log(`===> api interceptors request error : ${error}`);
      return Promise.reject(error);
    }
);

api.interceptors.response.use(
    async (response) => {
      if (
          response.status === 200 &&
          response.config.url === '/admin/api/auth'
      ) {
        if (response.data.accessToken) {
          const jwtObject = jwt_decode(response.data.accessToken);
          await axios
          .get(
              `${baseURL}/admin/api/centerStaffRole/centerMenu/${jwtObject.cid}/${jwtObject.rid}`,
              {
                headers: {
                  Authorization: `Bearer ${response.data.accessToken}`,
                },
              }
          )
          .then((res) => {
            localStorage.setItem(
                'userMenu',
                JSON.stringify(res.data)
            );
          });
        }
      }
      return response;
    },

    async (error) => {
      // 응답 에러 처리를 작성
      console.log(`===> api interceptors response error : ${error}`);
      if (error.response && error.response.status === 401) {
        handleTokenRefreshFailure();
      }

      return Promise.reject(error);
    }
);

export const getSendTemplateDetail = async function(templateSendId) {
  return axios
  .get(
      `${baseURL}/admin/api/center/0/staff/0/contract/template/send/${templateSendId}`,
      {
        headers: {
        },
      }
  )
  .then((res) => {
    return res
  });
};

export const getSendTemplateList = async function(params) {
  return axios
  .get(
      `${baseURL}/admin/api/center/contract/list/0`, {
        params
      },
  )
  .then((res) => {
    return res
  });
};

// === 관리자 결제 알림 (인앱 알림함) ===
export const getNotiUnreadCount = function (centerId) {
  return api.get(`/admin/api/center/${centerId}/staff/notification/unread-count`).then((res) => res.data);
};

export const getNotiList = function (centerId, params = {}) {
  return api.get(`/admin/api/center/${centerId}/staff/notification`, { params }).then((res) => res.data);
};

export const markNotiAllRead = function (centerId) {
  return api.patch(`/admin/api/center/${centerId}/staff/notification/read-all`).then((res) => res.data);
};

export default api;
